export const STORAGE_ADDRESS = 'StorageAddress';
export const StorageAddressKindValues = [
    'picking',
    'bulk',
    'staging',
    'dock',
];
/** pt-BR labels for {@link StorageAddressKind}. */
export const STORAGE_ADDRESS_KIND_LABELS = {
    picking: 'Picking',
    bulk: 'Armazenagem',
    staging: 'Preparação',
    dock: 'Doca',
};
//# sourceMappingURL=storage-address.js.map